export default {
    
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    validation: {
    }
  },  
}
